module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/placement.540e67d3.svg";